import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { SharedModule } from '../../core/shared.module';
import { CommonModule } from '@angular/common';
import { AnagraficaEnte } from '../../interfaces/anagrafica-ente.interface';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '../../service/app.service';
import {
  ItTableComponent,
  ItSortHeaderComponent,
  ItSortDirective,
  ItSortEvent,
  ItButtonDirective,
  ItIconComponent,
  ItModalComponent,
  ItPaginationComponent,
} from 'design-angular-kit';
import { Observable, of } from 'rxjs';
import { LoaderService } from '../../service/loader.service';

@Component({
  selector: 'app-enti',
  standalone: true,
  templateUrl: './enti.component.html',
  imports: [
    SharedModule,
    CommonModule,
    ItTableComponent,
    ItSortHeaderComponent,
    ItSortDirective,
    ItButtonDirective,
    ItIconComponent,
    ItModalComponent,
    ItPaginationComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EntiComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private appService: AppService,
    private cd: ChangeDetectorRef,
    private loader: LoaderService,
  ) {}
  listEnti: any[] = [];
  totalPages: number = 0;
  currentPage: number = 0;
  pageOffset: number = 10;

  ngOnInit(): void {
    this.listEnti = this.route.snapshot.data['data'];
  }

  ngAfterViewInit(): void {
    this.getPage();
    this.cd.detectChanges();
  }

  listInit(list: AnagraficaEnte[]): void {
    this.listEnti = list;
    this.cd.detectChanges();
  }

  goToEnte(id: number) {
    this.appService.ente = this.listEnti.find(
      (el: AnagraficaEnte) => el.idEnte === id
    );
    this.appService.user.idEnte = id;
    this.router.navigate(['/ente']);
  }

  sortData(event: ItSortEvent) {
    this.getPage(this.currentPage, event);
  }

  getPage(page: number = 0, sort?: ItSortEvent): void {
    this.loader.show();
    this.paginator(page, this.pageOffset)
      .subscribe(data => {
        data.list = data.list.sort((a, b) => {
          if (sort?.direction === 'asc') {
            return a[sort.active] > b[sort.active] ? 1 : -1;
          } else if (sort?.direction === 'desc') {
            return a[sort.active] < b[sort.active] ? 1 : -1;
          }
          return 0;
        });
        this.listInit(data.list);
        this.currentPage = page;
        this.totalPages = Math.ceil(data.totalItemsCount / this.pageOffset);
        this.loader.hide();
      });
  }

  changerEvent(value: number): void {
    this.pageOffset = value;
    this.getPage();
  }

  private paginator(page: number, pageOffset: number): Observable<{ list: AnagraficaEnte[]; totalItemsCount: number }> {
    const startIndex = (page) * pageOffset;
    const endIndex = startIndex + pageOffset;
    const list = this.route.snapshot.data['data'].slice(startIndex, endIndex);

    return of({
      list: list,
      totalItemsCount: this.route.snapshot.data['data'].length,
    });
  }
}
